// iframe-modal.service.ts
import { Injectable, Injector } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

import { IframeModalComponent } from './iframe-modal.component';

@Injectable({ providedIn: 'root' })
export class IframeModalService {
  private overlayRef: OverlayRef | null = null;

  constructor(
    private overlay: Overlay,
    private injector: Injector
  ) {}

  open(
    pageSrc: string,
    pageTitle?: string,
    requireAuth = false,
    onCloseCallback?: () => void
  ) {
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-dark-backdrop',
      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically(),
    });

    const iframePortal = new ComponentPortal(
      IframeModalComponent,
      null,
      this.injector
    );
    const componentRef = this.overlayRef.attach(iframePortal);

    componentRef.instance.pageSrc = pageSrc;
    componentRef.instance.pageTitle = pageTitle;
    componentRef.instance.requireAuth = requireAuth;

    componentRef.instance.closeModal.subscribe(() => {
      this.close();
      if (onCloseCallback) onCloseCallback();
    });
  }

  close() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }
}
